import { useResetLinkThemesMutation } from '@dtx-company/inter-app/src/redux/slices/flowpageApiSlice/resetLinkThemes'

export function useResetLinkThemes(): any {
  const [resetLinkThemesMutation] = useResetLinkThemesMutation()
  return resetLinkThemesMutation
}
